export default {

  displayDates: {
    today: "",
    tomorrow: "",
    dayAfterTomorrow: "",
  },
  selectedDateDisplay1: "today",
  vesselNameJapaneseFlg:  true,
  pilotColorFlg: false,
  selectedTaskId: null,
  selectedColumnKey: null,
  summaryDialogShowPopup: false,

  masterMap: {},
  monitorSettingMap: {},
  destinationWorkHeaders: [],
  destinationWorkTasksMap:{
    // <YYYYMMDD>: destinationWorkTasks
  },
  lastUpdatedTimeMap: {},

  lastUpdatedForMasters:  -1,
  lastUpdatedForMonitors: -1,
  lastUpdatedForColumns:  -1,
  lastUpdatedForTasks:    -1,

  firestoreSubscribeList: [],
}
